module.exports = __webpack_public_path__ + "static/logo-white-68d5f459bedee85698675e60429ad9c4.svg";